import { Annotation } from "./annotation.js" 
import { HighlightAnnotation } from "./highlightAnnotation.js"
export class AnnotationMemory {
    constructor(orientation) {
        this.annotationArray = [] // annotation memory
        this.undoArray = [] // undo memory
        this.redoArray = [] // redo memory
        this.movingStartAnnotationCoords = [] // moving annotation temporary memory
        this.orientation = orientation
        this.clearMode = false
    }

    getAnnotationArray() {
        return this.annotationArray
    }

    setOrientation(orientation) {
        this.orientation = orientation
    }

    setClearMode(mode) {
        this.clearMode = mode
    }

    loadAnnotations(annotationsJson, canvasElement, zoomOptions) {
        for (var [index, annotation] of annotationsJson.entries()) {
            if (annotation.type == "square" || annotation.type == "circle" || annotation.type == "drawing" || annotation.type == "text") {
                this.addAnnotation(new Annotation(annotation.type, canvasElement, annotation.toolSize, annotation.coords, annotation.options, zoomOptions, annotation.options.orientation, index), false, false, true)
            } else if (annotation.type == "highlight") {
                if (annotation.options.zoom != 0) zoomOptions.zoom = annotation.options.zoom
                this.addAnnotation(new HighlightAnnotation(annotation.type, canvasElement, null, annotation.selection, annotation.options, zoomOptions, annotation.options.orientation, index), false, false, true)
            }
        }
    }

    drawAnnotation(annotation, loaded = false, redo = false) {
        // for (var annotation of this.annotationArray) {
        switch (annotation.type) {
            case "circle":
                annotation.drawCircle()
                break;
            case "square":
                annotation.drawSquare()
                break;
            case "highlight":
                // get all other highlight annotations on selection
                annotation.drawHighlight(loaded, redo)
                if (loaded == false) this.getHighlightCollision(annotation)
                break;
            case "drawing":
                annotation.drawDrawing()
                break
            case "text":
                annotation.drawText()
                break
            default:
                break;
        }
        // }
    }

    getHighlights() {
        return this.annotationArray.filter(aa => aa.type == "highlight")
    }

    getHighlightCollision(currentHighlight) {
        var allHighlights = this.getHighlights()
        var annotationsToRemove = []
        if (currentHighlight && currentHighlight.selection != null && currentHighlight.selection.length > 0) {
            for (var currentHLSelection of currentHighlight.selection) { // for every line of current highlight
                // check if current selection overlaps any other highlight's selection
                for (var highlight of allHighlights) { // for every highlight that exist on page
                    if (this.orientation == "portrait") {
                        if (currentHighlight.id != highlight.id && highlight.selection != null && highlight.selection.length > 0) { // if current highlight is not selected  highlight then detect, otherwise skip
                            for (var [lineIndex, highlightSelection] of highlight.selection.entries()) { // for selected highlight per line, detect
                                if (highlightSelection != null && (currentHLSelection.offsetTop <= highlightSelection.offsetTop + 5 && currentHLSelection.offsetTop >= highlightSelection.offsetTop - 5) || (currentHLSelection.top <= highlightSelection.top + 5 && currentHLSelection.top >= highlightSelection.top - 5)) {
                                    // full-overlap
                                    if (
                                        currentHLSelection.left <= highlightSelection.left &&
                                        (currentHLSelection.left + currentHLSelection.width) >= (highlightSelection.left + highlightSelection.width)
                                    ) {
                                        // delete and remove from memory
                                        highlight.removeAnnotation(lineIndex)
                                        annotationsToRemove.push(highlight.id)
                                    }
                                    // inner-overlap
                                    else if (
                                        currentHLSelection.left >= highlightSelection.left && 
                                        currentHLSelection.left <= (highlightSelection.left + highlightSelection.width) && 
                                        (currentHLSelection.left + currentHLSelection.width) >= highlightSelection.left &&
                                        (currentHLSelection.left + currentHLSelection.width) <= (highlightSelection.left + highlightSelection.width)
                                    ) {
                                        if (currentHighlight.options.color == highlight.options.color) {
                                            currentHighlight.removeAnnotation(lineIndex)
                                            annotationsToRemove.push(currentHighlight.id)
                                        } else {
                                            // split annotation into two...
                                            var newHL = highlight.splitAnnotationHorizontal(lineIndex, currentHLSelection.left, currentHLSelection.left + currentHLSelection.width, currentHLSelection.top)
                                            this.addAnnotation(new HighlightAnnotation(currentHighlight.type, currentHighlight.canvasListener, newHL.highlightElement, newHL.selection, newHL.options, newHL.zoomOptions, currentHighlight.orientation, this.getLastIndex() + 1), true, true, true)
                                        }
                                    }
                                    // pre-overlap
                                    else if (
                                        (currentHLSelection.left + currentHLSelection.width) >= highlightSelection.left && 
                                        (currentHLSelection.left + currentHLSelection.width) <= (highlightSelection.left + highlightSelection.width)
                                    ) {
                                        // shrink highlightSelection.left to (currentHLSelection.left + currentHLSelection.width)
                                        highlight.shrinkLeft(lineIndex, currentHLSelection.left + currentHLSelection.width)
                                    }
                                    // post-overlap
                                    else if (
                                        currentHLSelection.left <= (highlightSelection.left + highlightSelection.width) && 
                                        currentHLSelection.left >= highlightSelection.left
                                    ) {
                                        highlight.shrinkRight(lineIndex, currentHLSelection.left)
                                    }
                                }
                            }
                        }
                    } else if (this.orientation == "landscape") {
                        if (currentHighlight.id != highlight.id && highlight.selection != null && highlight.selection.length > 0) { 
                            for (var [lineIndex, highlightSelection] of highlight.selection.entries()) { // for selected highlight per line, detect
                                if (highlightSelection != null && (currentHLSelection.x <= highlightSelection.x + 5 && currentHLSelection.x >= highlightSelection.x - 5) || (currentHLSelection.left <= highlightSelection.left + 5 && currentHLSelection.left >= highlightSelection.left - 5)) {
                                    // full-overlap
                                    if (
                                        currentHLSelection.top <= highlightSelection.top &&
                                        (currentHLSelection.top + currentHLSelection.height) >= (highlightSelection.top + highlightSelection.height)
                                    ) {
                                        // delete and remove from memory
                                        highlight.removeAnnotation(lineIndex)
                                        annotationsToRemove.push(highlight.id)
                                    }
                                    // inner-overlap
                                    else if (
                                        currentHLSelection.top >= highlightSelection.top && 
                                        currentHLSelection.top <= (highlightSelection.top + highlightSelection.height) && 
                                        (currentHLSelection.top + currentHLSelection.height) >= highlightSelection.top &&
                                        (currentHLSelection.top + currentHLSelection.height) <= (highlightSelection.top + highlightSelection.height)
                                    ) {
                                        if (currentHighlight.options.color == highlight.options.color) {
                                            currentHighlight.removeAnnotation(lineIndex)
                                            annotationsToRemove.push(currentHighlight.id)
                                        } else {
                                            // split annotation into two...
                                            var newHL = highlight.splitAnnotationVertical(lineIndex, currentHLSelection.top, currentHLSelection.top + currentHLSelection.height)
                                            this.addAnnotation(new HighlightAnnotation(currentHighlight.type, currentHighlight.canvasListener, newHL.highlightElement, newHL.selection, newHL.options, newHL.zoomOptions, currentHighlight.orientation, this.getLastIndex() + 1), true, true, true)
                                        }
                                    }
                                    // pre-overlap
                                    else if (
                                        (currentHLSelection.top + currentHLSelection.height) >= highlightSelection.top && 
                                        (currentHLSelection.top + currentHLSelection.height) <= (highlightSelection.top + highlightSelection.height)
                                    ) {
                                        // shrink highlightSelection.top to (currentHLSelection.top + currentHLSelection.height)
                                        highlight.shrinkDown(lineIndex, currentHLSelection.top + currentHLSelection.height)
                                    }
                                    // post-overlap
                                    else if (
                                        currentHLSelection.top <= (highlightSelection.top + highlightSelection.height) && 
                                        currentHLSelection.top >= highlightSelection.top
                                    ) {
                                        highlight.shrinkUp(lineIndex, currentHLSelection.top)
                                    }
                                }
                            }
                        }

                    }
                }
            }
            for (var i = new Set(annotationsToRemove).length - 1; i >= 0; i--) {
                this.annotationArray.splice(annotationsToRemove[i], 1)
            }
            // for (var id of new Set(annotationsToRemove)) {
            //     this.annotationArray.splice(this.annotationArray.findIndex(aa => aa.id == id), 1)
            // }
        }
    }

    removeAnnotationWithClearTool(x1, y1, x2, y2, cbound) {
        var annotationsToRemove = []
        var annotations = this.getAnnotationArray()
        for (var annotation of annotations) {
            if (annotation.type == "highlight") {
                for (var [index, hl] of annotation.HLlines.entries()) {
                    var selection = hl[0].getBoundingClientRect()
                    if ((y1 >= selection.top && y1 <= selection.top + selection.height) || (y2 >= selection.top && y2 <= selection.top + selection.height)) {
                        if ( 
                            (x1 > selection.left &&
                            x1 < selection.left + selection.width) ||
                            (x2 > selection.left &&
                            x2 < selection.left + selection.width )
                        ) {
                            annotation.removeAnnotation(index)
                        }
                    }
                }
                var widths = annotation.selection.map(s => s.width)
                if (widths.length == 1 && widths[0] < 1) {
                    annotationsToRemove.push(annotation.id)
                } else if (annotation.selection.length == 0) {
                    annotationsToRemove.push(annotation.id)
                }
            } else if (annotation.type == "drawing") {
                if (
                    x1 >= annotation.hitbox.x1 + cbound.left &&
                    x2 <= annotation.hitbox.x4 + cbound.left &&
                    y1 >= annotation.hitbox.y1 + cbound.top &&
                    y2 <= annotation.hitbox.y4 + cbound.top
                ) {
                    this.removeAnnotation(annotation, true, true)
                }
            }
        }
        if (annotationsToRemove.length > 0) {
            for (var del of new Set(annotationsToRemove)) {
                this.annotationArray.splice(this.annotationArray.findIndex(aa => aa.id == del), 1)
            }
        }
    }

    annotationZoom(zoomOptions) {
        for (var annotation of this.getAnnotationArray()) {
            // apply zoom to annotation
            annotation.zoomOptions = zoomOptions
            annotation.redraw()
            if (annotation.type == "square" || annotation.type == "circle" || annotation.type == "drawing" || annotation.type == "text") {
                this.createListeners(annotation)
            }
        }
    }

    getLastIndex() {
        return this.annotationArray.length
    }

    getLastId() {
        return this.annotationArray.length > 0 ? this.annotationArray.at(-1).id : 0
    }

    addAnnotation(annotation, undo = false, userInteraction = true, loaded = false, redo = false) {
        this.annotationArray.push(annotation)

        this.drawAnnotation(annotation, loaded, redo)

        if (annotation.type == "highlight") {
            annotation.event = "add"

            if (!undo) {
                this.addToUndoArray(annotation)
                if (userInteraction) this.redoArray = []
            } else {
                this.addToRedoArray(annotation)
            }
        } else if (annotation.type == "square" || annotation.type == "circle" || annotation.type == "drawing" || annotation.type == "text") {
            this.createListeners(annotation)
            annotation.event = "add"

            if (!undo) {
                this.addToUndoArray(annotation)
                if (userInteraction) this.redoArray = []
            } else {
                this.addToRedoArray(annotation)
            }
        }
    }

    createListeners(annotation) {

        if (annotation.canvas.onkeyup == null) {
            annotation.canvas.onkeyup = (e) => {
                if ((e.key == "Delete" || e.key == "Backspace") && annotation.selected == true) {
                    // Delete from memory and element as well
                    this.removeAnnotation(annotation)
                }
            }
        }

        if (annotation.canvas.onclick == null) {
            annotation.canvas.onclick = (e) => {
                if (this.clearMode == false) {
                    for (var removeAnnotationHitBox of this.getAnnotationArray()) {
                        removeAnnotationHitBox.removeHitbox()
                    }
                    if (annotation.canvas.style.border == "1px dashed blue" && annotation.lastEvent == "onclick") {
                        annotation.removeHitbox()
                    } else {
                        annotation.drawHitbox()
                    }
                    annotation.lastEvent = "onclick"
                }
            }
        }

        if (annotation.canvas.onmousedown == null) {
            annotation.canvas.onmousedown = (e) => {
                annotation.mouseDownEvent = true
                annotation.offset = [
                    annotation.canvas.offsetLeft - e.clientX,
                    annotation.canvas.offsetTop - e.clientY
                ];
                if (annotation.type == "drawing") {
                    this.movingStartAnnotationCoords = [e.clientX, e.clientY]
                } else {
                    this.movingStartAnnotationCoords = JSON.parse(JSON.stringify(annotation.coords))
                }
                annotation.canvas.style.cursor = "grabbing"
            }
        }

        if (annotation.canvas.onmousemove == null) {
            annotation.canvas.onmousemove = (e) => {
                annotation.canvas.style.cursor = "grab"
                if (annotation.mouseDownEvent == true) {
                    let x = e.clientX
                    let y = e.clientY
                    annotation.canvas.style.cursor = "grabbing"
                    if (annotation.selected == false && this.clearMode == false) {
                        annotation.drawHitbox()
                    }
                    
                    annotation.lastEvent = "onmousemove"
                    if (annotation.type == "drawing") {
                        this.animate(annotation, x, y)
                    } else if (annotation.mouseDownEvent == true) {
                        annotation.coords[0] = x
                        annotation.coords[1] = y
                        this.animate(annotation, x, y)
                    }
                }
            }
        }

        if (annotation.canvas.onmouseup == null) {
            annotation.canvas.onmouseup = (e) => {
                if (annotation.mouseDownEvent == true) {
                    if (annotation.type == "drawing") {
                        annotation.canvas.style.cursor = "cursor"
                        annotation.mouseDownEvent = false
                        let x = e.clientX
                        let y = e.clientY

                        let xDiff = x - this.movingStartAnnotationCoords[0]
                        let yDiff = y - this.movingStartAnnotationCoords[1]

                        for (var coord of annotation.coords) {
                            if (coord.length > 1) {
                                coord[0] += xDiff
                                coord[1] += yDiff
                            }
                        }
                        this.addToUndoArray(copyAnnotation)
                        annotation.setHitboxCoords(null, null)
                    } else {
                        if (annotation.coords[0] != this.movingStartAnnotationCoords[0] || annotation.coords[1] != this.movingStartAnnotationCoords[1]) {
                            // var copyAnnotation = new Annotation(annotation.type, annotation.canvasElement, annotation.spanElement, annotation.toolSize, this.movingStartAnnotationCoords, annotation.options, annotation.zoom, annotation.orientation, annotation.index)
                            var copyAnnotation = Object.assign({}, annotation)
                            copyAnnotation.event = "move"
                            copyAnnotation.coords = this.movingStartAnnotationCoords
                            copyAnnotation.newLocationAnnotation = annotation
                            this.addToUndoArray(copyAnnotation)
                            annotation.setHitboxCoords(null, null)
                        }
                        annotation.canvas.style.cursor = "cursor"
                        annotation.mouseDownEvent = false
                    }
                }
            }
        }
    }

    removeAnnotation(annotation, undo = false, userInteraction = true) {
        if (annotation.type != "highlight") {
            annotation.canvas.remove()
            this.annotationArray.splice(this.annotationArray.findIndex(anon => anon.id == annotation.id), 1)
            annotation.event = "remove"
            if (!undo) {
                this.addToUndoArray(annotation)
                if (userInteraction) this.redoArray = []
            } else {
                this.addToRedoArray(annotation)
            }
        } else {
            annotation.removeAnnotation(null)
            this.annotationArray.splice(this.annotationArray.findIndex(anon => anon.id == annotation.id), 1)
            annotation.event = "remove"

            if (!undo) { 
                this.addToUndoArray(annotation)
                if (userInteraction) this.redoArray = []
            } else {
                this.addToRedoArray(annotation)
            }
        }
    }

    moveAnnotation(annotation, newLocation = false, undo = false, userInteraction = false, zoomEvent = false) {
        this.animateWithCoords(newLocation ? annotation.newLocationAnnotation : annotation)
        if (zoomEvent == false) {
            if (!undo) {
                this.addToUndoArray(annotation)
                if (userInteraction) this.redoArray = []
            } else {
                this.addToRedoArray(annotation)
            }
        }
    } 

    animate(annotation, x, y) {
        // if (annotation.type == "square" || annotation.type == "circle" || annotation.type == "drawing") {
        annotation.canvas.style.left = (x + annotation.offset[0]) + "px"
        annotation.canvas.style.top = (y + annotation.offset[1]) + "px"
        if (annotation.type != "drawing")
            annotation.coords = [x + annotation.offset[0], y + annotation.offset[1]]
        // }
    }

    animateWithCoords(annotation) {
        if (annotation.type == "square") {
            annotation.canvas.style.left = annotation.coords[0] - annotation.toolSize[0]/2 + "px"
            annotation.canvas.style.top = annotation.coords[1] - annotation.toolSize[1]/2 + "px"
        } else if (annotation.type == "circle") {
            annotation.canvas.style.left = annotation.coords[0] - annotation.toolSize[0] + "px"
            annotation.canvas.style.top = annotation.coords[1] - annotation.toolSize[0] + "px"
        }
    }

    exportAnnotations() {
        // var exportJsonStructure = [
        //     {
        //         type: "",
        //         coords: [], // [x, y]
        //         toolSize: [], // [width, height] or [radius]
        //         options: {
        //             color: "",
        //             thickness: 0,
        //             filled: false
        //         },
        //         spanElement: null, // work in progress
        //     }
        // ]

        var exportJsonStructure = []


        for (var annotation of this.annotationArray) {
            switch (annotation.type) {
                case "square":
                case "circle":
                    exportJsonStructure.push(
                        {
                            type: annotation.type,
                            coords: annotation.coords, // [x, y]
                            toolSize: annotation.toolSize, // [width, height] or [radius]
                            options: {
                                color: annotation.options.color,
                                lineThickness: annotation.options.lineThickness,
                                filled: annotation.options.filled
                            }
                        }
                    )
                    break
                case "drawing":
                    exportJsonStructure.push(
                        {
                            type: annotation.type,
                            coords: annotation.coords, // [[x, y]]
                            options: {
                                color: annotation.options.color,
                                lineThickness: annotation.options.lineThickness
                            }
                        }
                    )
                    break
                case "text":
                    exportJsonStructure.push(
                        {
                            type: annotation.type,
                            coords: annotation.coords, // [x, y]
                            options: {
                                text: annotation.options.text
                            }
                        }
                    )
                    break
                case "highlight":
                    exportJsonStructure.push(
                        {
                            type: annotation.type,
                            selection: annotation.selection,
                            options: {
                                color: annotation.options.color,
                                pageOffset: annotation.options.pageOffset,
                                pageTopOffset: annotation.options.pageTopOffset,
                                zoom: annotation.createdAtZoomLevel,
                                orientation: annotation.createdAtOrientation
                            }
                        }
                    )
                    break
            
                default:
                    break;
            }
        }

        return exportJsonStructure
    }

    addToUndoArray(annotation) {
        this.undoArray.push(annotation)
    }

    addToRedoArray(annotation) {
        this.redoArray.push(annotation)
    }

    undoLastAction() { // all actions must go into the undoArray
        if (this.undoArray.length > 0) {
            var lastActionAnnotation = this.undoArray.pop()
            switch (lastActionAnnotation.event) {
                case "add": // annotation was added, remove
                    this.removeAnnotation(lastActionAnnotation, true, false)
                    // remove all move events from redo with the same id
                    var removeFromRedoArr = []
                    for (var [index, redo] of this.redoArray.entries()) {
                        if (redo.id == lastActionAnnotation.id && redo.event == "move") {
                            removeFromRedoArr.push(index)
                        }
                    }
                    for (var removing of removeFromRedoArr) {
                        this.redoArray.splice(removing, 1)
                    }
                    break;
                case "remove": // annotation was removed, add again
                    this.addAnnotation(lastActionAnnotation, true, false)
                    
                    break;
                case "move":
                    // this.removeAnnotation(lastActionAnnotation, true, false)
                    // this.addAnnotation(lastActionAnnotation.newLocationAnnotation, true, false)
                    this.moveAnnotation(lastActionAnnotation, false, true, false)
                default:
                    break;
            }
        }
    }

    redoLastUndo() { // only redo the undo
        if (this.redoArray.length > 0) {
            var lastActionAnnotation = this.redoArray.pop()
            
            switch (lastActionAnnotation.event) {
                case "add": // annotation was added, remove
                    this.removeAnnotation(lastActionAnnotation, false, false, false)
                    break;
                case "remove": // annotation was removed, add again
                    this.addAnnotation(lastActionAnnotation, false, false, false, true)
                    break;
                case "move":
                    // this.removeAnnotation(lastActionAnnotation.newLocationAnnotation, false, false)
                    // this.addAnnotation(lastActionAnnotation, false, false)
                    this.moveAnnotation(lastActionAnnotation, true, false, false)
                default:
                    break;
            }
        }
    }

    printUndo() {
        console.log(this.undoArray)
    }
    
    printRedo() {
        console.log(this.redoArray)
    }

    removeAll(annotationType) {
        for (var annotation of this.getAnnotationArray()) {
            if (annotation.type == annotationType) {
                this.removeAnnotation(annotation, false, false)
            }
        }
    }
}
